// Libs
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

// Utils
import capitalize from '../../../../../utils/capitalize';

const VERACORE_FAILED_STATUS = 'VERACORE FAILED';

const getDisplayStatus = (status) =>
  status === VERACORE_FAILED_STATUS ? 'ORDERED' : status;

const OrderCardStatus = ({ order, isMobileMode, gridPropValues, classes }) => (
  <Grid
    item
    flexBasis={gridPropValues({
      lgSize: 2,
      unit: '%',
    })}
    order={gridPropValues({
      lgSize: 7,
      mdSize: 3,
    })}>
    <Box
      display="flex"
      flexDirection="column"
      data-testid="order-status"
      paddingLeft={isMobileMode ? '20px' : 0}>
      <Typography className={classes.headerText}>Status:</Typography>
      <Typography className={classes.text}>
        {capitalize(getDisplayStatus(order?.status), true)}
      </Typography>
    </Box>
  </Grid>
);

export default OrderCardStatus;
